import { StaticLink } from '@silvertours/common-landingpages-view';

export const useHeader = () => ({
  getLinks: (staticLinks: StaticLink[]) =>
    staticLinks.filter(({ type }) => type === 'main'),
});
